import React from 'react';
import KioskHeader from '../components/Esper/Kiosk/KioskHeader';
import Layout from '../layout';
import KioskFeatures from '../components/Esper/Kiosk/KioskFeatures';
import KioskSecondPage from '../components/Esper/Kiosk/KioskSecondPage';
import KioskSectionFive from '../components/Esper/Kiosk/KioskSectionFive';
import KioskOGImage from '../assets/v2/png/kiosk_hero.jpg';
import messages from '../i18n/en';

export default (props: any) => (
  <Layout
    ogImage={KioskOGImage}
    messages={messages}
    title={'Full-Stack Android Kiosk Mode Management Solution'}
    description={`Esper's Platform offers full Android Kiosk Mode software features to lockdown, manage, and secure your Android Kiosk Hardware and improve your Kiosk Mode apps.`}
    keywords={`kiosk app,Android Kiosk Mode,android lockdown,kiosk lockdown software,kiosk management software,Kiosk Security,kiosk software,kiosk browser,kiosk app android,android tablet kiosk mode,android tablet kiosk,android kiosk software`}
    className="first-page"
    location={props.location}
  >
    <KioskHeader />
    <KioskSecondPage />
    <KioskFeatures />
    <KioskSectionFive />
  </Layout>
);
